import { MbAnagraficaDevice } from "../mb_anagrafiche/mb_tables/mb_anagrafica_device";
import { MbMessage } from "../mb_components/mb_message";

const MbValidatorDevice = ({callbackFromValidator}) => {

    return (
        <>
            <MbMessage title="Dispositivi" helper="Selezionare un dispositivo" open isFullscreen>
                <div style={{paddingLeft: "30px", paddingRight: "30px"}}>
                    <MbAnagraficaDevice isValidator callbackFromValidator={(item) => {
                        callbackFromValidator(item);
                    }}/>
                </div>
            </MbMessage>
        </>
    );
};

export {
    MbValidatorDevice
}